export class AttributeCode {
  static readonly AgeGroup = new AttributeCode("age_group")
  static readonly Gender = new AttributeCode("gender")
  static readonly InterviewModality = new AttributeCode("modalite_de_l_entretien")
  static readonly PrimaryProblematic = new AttributeCode("problematique_primaire")

  static fromString(code: string): AttributeCode {
    switch (code) {
      case "age_group":
        return AttributeCode.AgeGroup
      case "gender":
        return AttributeCode.Gender
      case "modalite_de_l_entretien":
        return AttributeCode.InterviewModality
      case "problematique_primaire":
        return AttributeCode.PrimaryProblematic
      default:
        throw new Error(`Unknown attribute code: ${code}`)
    }
  }

  static getAllValues(): AttributeCode[] {
    return [
      AttributeCode.AgeGroup,
      AttributeCode.Gender,
      AttributeCode.InterviewModality,
      AttributeCode.PrimaryProblematic,
    ]
  }

  protected constructor(public readonly value: string) {}

  public toString(): string {
    return this.value
  }
}
